import type { Components } from 'react-markdown';

/**
 * Enlaces de las respuestas de los agentes (2026-10-21, pedido David):
 *  - siempre en una pestaña nueva (el chat no se pierde);
 *  - URLs del SEA normalizadas: el modelo a veces reescribe la fecha de la ruta con guiones
 *    (`/publicaciones/2026-09-01/…`, `/archivos/2025-07-25/…`) y la forma real es con barras
 *    (`/2026/09/01/`). Las herramientas entregan la URL correcta; esto corrige solo la escritura.
 */
const RUTA_SEA = /(https?:\/\/(?:firma|seia)\.sea\.gob\.cl\/(?:publicaciones|archivos))\/(\d{4})-(\d{2})-(\d{2})\//g;

export function normalizarUrlsSea(texto: string): string {
  return texto.replace(RUTA_SEA, '$1/$2/$3/$4/');
}

export function EnlaceExterno({ href, children }: { href?: string; children?: React.ReactNode }) {
  const destino = typeof href === 'string' ? normalizarUrlsSea(href) : href;
  const interno = typeof destino === 'string' && destino.startsWith('#');
  return interno ? (
    <a href={destino}>{children}</a>
  ) : (
    <a href={destino} target="_blank" rel="noopener noreferrer">{children}</a>
  );
}

/** `components` para react-markdown: todo enlace abre en pestaña nueva con la URL del SEA corregida. */
export const componentesEnlaces: Pick<Components, 'a'> = {
  a: ({ node: _node, href, children }) => <EnlaceExterno href={href}>{children}</EnlaceExterno>,
};
